export default __webpack_public_path__ + "static/media/wash.c4124479.svg";